<div class="p-25" id="app-consumer-sign-in">
<h2 mat-dialog-title class="text">{{ text !== "" ? text : 'Please install wallet to continue Crypto Payments.' }}</h2>
<mat-dialog-content class="mat-typography">
    <div>
        <div class="connect-metamask" width="44" *ngIf="network !== 'solana'">
        <img src="../../../../../assets/metamask.svg"/>
        <a href="https://metamask.io/download/" target="_blank" class="ml-3 metamask-link">Get MetaMask</a>
        </div>
    </div>
    <div class="connect-metamask" width="44" *ngIf="network === 'solana'">
        <img src="../../../../../assets/Phantom.svg"/>
        <a href="https://phantom.app/download" target="_blank" class="ml-3 metamask-link">Get Phantom</a>
        </div>
</mat-dialog-content>
</div>

